import { makeStyles } from '@fluentui/react-theme-provider';
import { tokens } from '@fluentui/react-components';

export const headerStyles = makeStyles({
  stickyHeader: {
    backgroundColor: 'inherit',
    position: 'sticky',
    top: 0,
    width: '100%',
    zIndex: 3,
  },

  headerBackGroundColor: {
    backgroundColor: tokens.colorPaletteBlueBorderActive,
  },

  headerContainer: {
    padding: '0 8px 1px 20px',
    height: 52.75,
    display: 'flex',
    '@media (max-width: 320px)': {
      paddingLeft: '8px',
      paddingRight: 0,
    },
  },

  linkButton: {
    backgroundColor: 'white',
    border: 0,
    borderBottom: `1px solid ${tokens.colorNeutralForeground1}`,
    ':hover': {
      backgroundColor: tokens.colorNeutralBackground2Hover,
    },
  },

  profileActionButton: {
    minWidth: 'auto',
    padding: 0,
    justifyContent: 'flex-start',
    fontWeight: 400,
  },

  brandStyle: {
    fontSize: 20,
    fontWeight: 600,
    color: 'white',
    textDecorationLine: 'none',
  },

  rightAlignedItem: {
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
  },

  leftAlignedItem: {
    display: 'flex',
    alignItems: 'center',
  },

  leftAlignedItemFlightStyle: {
    width: '100%',
    color: 'white',
  },

  libraryIconContainer: {
    borderRadius: 4,
    width: 42,
    height: 42,
    cursor: 'pointer',
  },

  subtitle: {
    lineHeight: 24,
    fontSize: 20,
    fontWeight: 800,
    width: '150px',
    marginLeft: 8,
    cursor: 'pointer',
    '@media (max-width: 320px)': {
      fontSize: 16,
      width: '120px',
      marginLeft: 4,
    },
  },

  link: {
    marginTop: '24px',
    marginBottom: '24px',
  },
  faqLink: {
    textDecorationLine: 'underline',
  },
});
